<template>
	<tr v-if="isShow">
		<th></th>
		<td>
			<label for="other_bool" style="margin-left:5px;"> <input type="checkbox" id="other_bool" v-model="code.other_bool" />{{ keyword }}</label>
		</td>
	</tr>
</template>
<script>
export default {
	name: 'CodeOtherBool',
	props: {
		code: {},
		code_type: {},
	},
	computed: {
		isICG() {
			return this.code_type === 'ICG';
		},
		isPT() {
			return this.code_type === 'PT';
		},
		isShow() {
			return this.isICG || this.isPT;
		},
		keyword() {
			let keyword;
			if (this.isICG) keyword = 'Retail Store';
			else if (this.isPT) keyword = 'Show credit on invoice print';
			return keyword;
		},
	},
};
</script>
